<template>
    <transition name="fade">
        <div style="width:100%;" :style="{ height: `${44 + statusBarHeight}px` }">
     <div class="header">
                <i @click="back()"></i>
                <div class="gamerLogo" v-if="!pageTitle"></div>
                <div class="textTitle" v-if="pageTitle">{{ pageTitle }}</div>
            </div>
        </div>
       
    </transition>
</template>
<script>
export default {
    name: "Header",
    props: {
        pageTitle: ''

    },
    data() {
        return {
            statusBarHeight: 44,
        };
    },
    mounted () {
        if(utils.browser.IsMobile()){
            var environmentParams = this.GSAppJsApi.UI.getUIEnvironmentParams();
            this.statusBarHeight = environmentParams.systemStatusBarHeight;
            // this.$emit("navigationBarHeightChange", 44 + this.statusBarHeight);
        }

    },
    methods: {
        back(){
            GSAppJsApi.UI.close();
        }

    },
    destroyed() {
    },
};
</script>
<style lang="scss" scoped>
.header{
     width: 100%;
     height: auto;
     position: fixed;
     top: 0;
     left: 0;
     z-index: 200;
     background: #3F362C url("../../assets/image/deadlock/数据展示页面的固定背景@3x.png") no-repeat top center / 700px 100vh;
     overflow: hidden;
    //  background-attachment: fixed;

     
     i {
        margin-left: 16px;
        margin-top: 56px;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url('../../assets/image/battlefield/icon_NavBack.png') no-repeat center / 20px;
     }

     .gamerLogo {
        position: absolute;
        top: 56px;
        width: 59px;
        left: 48.5%;
        margin-left: -24.5px;
        height: 15px;
        background: url('../../assets/image/battlefield/gamerskyLogo.png') no-repeat center / 59px 15px;
        opacity: 0.5;

     }
     .textTitle {
        position: absolute;

        top: 56px;
        width: 200px;
        left: 50%;
        margin-left: -100px;
        font-size: 18px;
        text-align: center;
        color: rgba(255,255,253,1);
        font-weight: bold;
     }
     
}
</style>
